import { authHeader, history } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
export const adminService = {
  noticeList,
  noticeCount,
  getArrestCountCityWise,
  getPreventiveActionViolators,
  getPreventiveActionViolatorsCount,
  getGunaAccusedListByDistrict,
  getGunaRegisterAdmin,
  noticeGraph,
  arrestGraph,
  gunaGraph,
  getResidentsByPoliceStation,
  getCriminalsByPoliceStationArea,
  getAccusedImageCount,
  getGunhaWithAccusedImage,
  getResidentsByPoliceStationSearch,
  getCriminalsByPoliceStationAreaSearch,
  getResidentsByPoliceStationByFilter,
  getCriminalsByPoliceStationAreaByFiter,
  getResidentsByPoliceStationByFilterExcelDownload,
  getCriminalsByPoliceStationAreaByFiterExcelDownload,
  getResidentsByPoliceStationById,
  getAccusedByIdImageCount,
  getResidentsByPoliceIdStationSearch,
  getResidentsByPoliceStationIdByFilter,
  getResidentsByPoliceStationByFilterExcelDownloadById,
  getDashboard,
  getGunhaDetailsByHeading,
  UserSnapShots,
  DistrictSnapShots,
  createHelpDeskFeedback,
  userWiseHelpDesk,
  getHelpDesk,
  getCompletedPreventiveActionsList,
  getCompletedPreventiveActionsCount,
  getOngoingPreventiveActionsList,
  getOngoingPreventiveActionsCount,
  getPreventiveActionsList,
  getPreventiveActionsCount,
  GetOnlineUserCount,
  mapCountCity,
  activeCityList,
  createSubCity,
  countCity,
  subCityList,
  mapCityList,
  ApiLogs,
  ApiLogsDetails,
  CctvLogAnalysis,
  CctvLogAnalysisDetails,
  getOverallCityWiseName,
  TotalCrimeCount,
  totalCrimeList,
  RenewProvision,
  HistoryVerification,
  crimeAlbumLog,
  generateAlbumId,
  getCrimeCrimeAlbumAccessLogs,
  SuspendedVerification,
  updateMobileAddress,
  getMobileData,
  getAccusedListWithTwoOrMoreCountByDistinct,
  getAccusedListWithTwoOrMoreCountById,
  getAccusedListWithTwoOrMoreListByDistinct,
  getAccusedListWithTwoOrMoreListById,
  getCriminalDetails,
  OnlineCityWiseUserOnline,
  NewDashboard,
  newDashboardMovementCardDetail,
  AdminNewDashboard,
  AdminNewDashboardAccusedDetail,
  RoleWiseDashboard,
  RoleWiseDashboardAccusedDetail,
  get2plusNewArophiPreventiveActionCount,
  get2plusNewArophiPreventiveActionPoliceStationCount,
  get2lusArophiCountGraph,
  get2lusArophiCountGraphPoliceStation,
  get2lusNewListAropiGraph,
  get2lusNewListAropiGraphPoliceStation,
  getPreventiveActionAnalytics,
  getPreventiveActionAnalyticsList,
  get2plusByIdCountGraph,
  getDistrictPreventiveActionAnalytics,
  getDistrictPreventiveActionAnalyticsList,
  getPoliceAdminPreventiveActionAnalytics,
  get2PlusNewAropiPostBharaliCountGraph,
  get2plusByIdCumulativeCountGraph,
  get2PlusNewAropiPostBharaliCumulativeCountGraph,
  GunhaHide,
  GunahaHideRequestList,
  deleteGunaHideReuqest,
  CctvMasterDetails,
  fuzzyList,
  crimeNullList,
  douableCRCrimeList,
  getTadipaarListByDistrict,
  getCctvDistrictsCity,
  addCctnsDistrict,
  UpdateDistrictOrder,
  GetOrderDistrict,
  aropiCountYear,
};
const baseUrl = config.apiGateway.baseUrl;

function noticeList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeList/`, requestOptions);
}
function noticeCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeCount/`, requestOptions);
}
function getArrestCountCityWise(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getArrestCountCityWise/`, requestOptions);
}

function getPreventiveActionViolators(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPreventiveActionViolators/`,
    requestOptions,
  );
}
function getPreventiveActionViolatorsCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPreventiveActionViolatorsCount/`,
    requestOptions,
  );
}
function getGunaAccusedListByDistrict(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getGunaAccusedListByDistrict/`,
    requestOptions,
  );
}
function getGunaRegisterAdmin(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGunaRegisterAdmin/`, requestOptions);
}
function noticeGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeGraph/`, requestOptions);
}
function arrestGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/arrestGraph/`, requestOptions);
}
function gunaGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/gunaGraph/`, requestOptions);
}
function getResidentsByPoliceStation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStation/`,
    requestOptions,
  );
}
function getCriminalsByPoliceStationArea(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsByPoliceStationArea/`,
    requestOptions,
  );
}
function getAccusedImageCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getAccusedImageCount/`, requestOptions);
}
function getGunhaWithAccusedImage(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGunhaWithAccusedImage/`, requestOptions);
}
function getResidentsByPoliceStationSearch(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationSearch/`,
    requestOptions,
  );
}
function getCriminalsByPoliceStationAreaSearch(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsByPoliceStationAreaSearch/`,
    requestOptions,
  );
}
function getResidentsByPoliceStationByFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationByFilter/`,
    requestOptions,
  );
}
function getCriminalsByPoliceStationAreaByFiter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsByPoliceStationAreaByFiter/`,
    requestOptions,
  );
}
function getResidentsByPoliceStationByFilterExcelDownload(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationByFilterExcelDownload/`,
    requestOptions,
  );
}
function getCriminalsByPoliceStationAreaByFiterExcelDownload(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsByPoliceStationAreaByFiterExcelDownload/`,
    requestOptions,
  );
}
function getResidentsByPoliceStationById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationById/`,
    requestOptions,
  );
}
function getAccusedByIdImageCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getAccusedByIdImageCount/`, requestOptions);
}
function getResidentsByPoliceIdStationSearch(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceIdStationSearch/`,
    requestOptions,
  );
}
function getResidentsByPoliceStationIdByFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationIdByFilter/`,
    requestOptions,
  );
}

function getResidentsByPoliceStationByFilterExcelDownloadById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationByFilterExcelDownloadById/`,
    requestOptions,
  );
}
function getDashboard(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/dashboard/`, requestOptions);
}
function getGunhaDetailsByHeading(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGunhaDetailsByHeading/`, requestOptions);
}
function UserSnapShots(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/UserSnapShots/`, requestOptions).then(
    handleResponse,
  );
}
function DistrictSnapShots(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/DistrictSnapShots/`, requestOptions).then(
    handleResponse,
  );
}
function createHelpDeskFeedback(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/createHelpDeskFeedback/`,
    requestOptions,
  ).then(handleResponse);
}
function userWiseHelpDesk(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/userWiseHelpDesk/`, requestOptions).then(
    handleResponse,
  );
}
function getHelpDesk() {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  return fetch(`${baseUrl}/criminal/getHelpDesk/`, requestOptions).then(
    handleResponse,
  );
}
function getCompletedPreventiveActionsList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getCompletedPreventiveActionsList/`,
    requestOptions,
  ).then(handleResponse);
}
function getCompletedPreventiveActionsCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getCompletedPreventiveActionsCount/`,
    requestOptions,
  ).then(handleResponse);
}
function getOngoingPreventiveActionsList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getOngoingPreventiveActionsList/`,
    requestOptions,
  ).then(handleResponse);
}
function getOngoingPreventiveActionsCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getOngoingPreventiveActionsCount/`,
    requestOptions,
  ).then(handleResponse);
}
function getPreventiveActionsList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getPreventiveActionsList/`,
    requestOptions,
  ).then(handleResponse);
}
function getPreventiveActionsCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getPreventiveActionsCount/`,
    requestOptions,
  ).then(handleResponse);
}
function GetOnlineUserCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/GetOnlineUserCount/`, requestOptions).then(
    handleResponse,
  );
}
function mapCountCity() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/mapCountCity/`, requestOptions).then(
    handleResponse,
  );
}
function activeCityList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/activeCityList/`, requestOptions).then(
    handleResponse,
  );
}
function createSubCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/createSubCity/`, requestOptions).then(
    handleResponse,
  );
}
function countCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/countCity/`, requestOptions).then(
    handleResponse,
  );
}
function subCityList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/subCityList/`, requestOptions).then(
    handleResponse,
  );
}
function mapCityList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/mapCityList/`, requestOptions).then(
    handleResponse,
  );
}
function ApiLogs(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/ApiLogs/`, requestOptions).then(
    handleResponse,
  );
}
function ApiLogsDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/ApiLogsDetails/`, requestOptions).then(
    handleResponse,
  );
}
function CctvLogAnalysis(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/CctvLogAnalysis/`, requestOptions).then(
    handleResponse,
  );
}
function CctvLogAnalysisDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/CctvLogAnalysisDetails/`,
    requestOptions,
  ).then(handleResponse);
}
function getOverallCityWiseName(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getOverallCityWiseName/`,
    requestOptions,
  ).then(handleResponse);
}
function TotalCrimeCount() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/TotalCrimeCount/`, requestOptions).then(
    handleResponse,
  );
}
function totalCrimeList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/totalCrimeList/`, requestOptions).then(
    handleResponse,
  );
}
function RenewProvision(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/renew-provision`, requestOptions).then(
    handleResponse,
  );
}
function HistoryVerification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/history-verification`, requestOptions).then(
    handleResponse,
  );
}
function crimeAlbumLog(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/crimeAlbumLog`, requestOptions).then(
    handleResponse,
  );
}
function generateAlbumId() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/generateAlbumId/`, requestOptions).then(
    handleResponse,
  );
}
function getCrimeCrimeAlbumAccessLogs() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getCrimeCrimeAlbumAccessLogs/`,
    requestOptions,
  ).then(handleResponse);
}
function SuspendedVerification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/suspend-verification/`, requestOptions).then(
    handleResponse,
  );
}
function updateMobileAddress(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/updateMobileAddress/`, requestOptions).then(
    handleResponse,
  );
}
function getMobileData(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/getMobileData/${id}`, requestOptions).then(
    handleResponse,
  );
}
function getAccusedListWithTwoOrMoreCountByDistinct(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreCountByDistinct/`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreCountById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreCountById/`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreListByDistinct(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreListByDistinct/`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreListById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreListById/`,
    requestOptions,
  ).then(handleResponse);
}
function getCriminalDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/getCriminalDetails/`, requestOptions).then(
    handleResponse,
  );
}
function OnlineCityWiseUserOnline(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/online-user-count/`, requestOptions).then(
    handleResponse,
  );
}
function NewDashboard(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/new-dashboard/`, requestOptions).then(
    handleResponse,
  );
}

function newDashboardMovementCardDetail(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/new-dashboard-movement-card`,
    requestOptions,
  ).then(handleResponse);
}

function AdminNewDashboard(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/new-admin-dashboard`, requestOptions).then(
    handleResponse,
  );
}

function AdminNewDashboardAccusedDetail(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/admin-new-dashboard-accused-detail`,
    requestOptions,
  ).then(handleResponse);
}

function RoleWiseDashboard(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/role-wise-dashboard`, requestOptions).then(
    handleResponse,
  );
}

function RoleWiseDashboardAccusedDetail(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/role-wise-dashboard-accused-detail`,
    requestOptions,
  ).then(handleResponse);
}
function get2plusNewArophiPreventiveActionCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2plusNewArophiPreventiveActionCount/`,
    requestOptions,
  ).then(handleResponse);
}

function get2plusNewArophiPreventiveActionPoliceStationCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2plusNewArophiPreventiveActionPoliceStationCount/`,
    requestOptions,
  ).then(handleResponse);
}
function get2lusArophiCountGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2lusArophiCountGraph/`,
    requestOptions,
  ).then(handleResponse);
}
function get2lusArophiCountGraphPoliceStation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2lusArophiCountGraphPoliceStation/`,
    requestOptions,
  ).then(handleResponse);
}
function get2lusNewListAropiGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2lusNewListAropiGraph/`,
    requestOptions,
  ).then(handleResponse);
}
function get2lusNewListAropiGraphPoliceStation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2lusNewListAropiGraphPoliceStation/`,
    requestOptions,
  ).then(handleResponse);
}
function getPreventiveActionAnalytics(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getPreventiveActionAnalytics/`,
    requestOptions,
  ).then(handleResponse);
}
function getPreventiveActionAnalyticsList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getPreventiveActionAnalyticsList/`,
    requestOptions,
  ).then(handleResponse);
}

function get2plusByIdCountGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2plusByIdCountGraph/`,
    requestOptions,
  ).then(handleResponse);
}
function getDistrictPreventiveActionAnalytics(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getDistrictPreventiveActionAnalytics/`,
    requestOptions,
  ).then(handleResponse);
}
function getDistrictPreventiveActionAnalyticsList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getDistrictPreventiveActionAnalyticsList/`,
    requestOptions,
  ).then(handleResponse);
}
function getPoliceAdminPreventiveActionAnalytics(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getPoliceAdminPreventiveActionAnalytics/`,
    requestOptions,
  ).then(handleResponse);
}
function get2PlusNewAropiPostBharaliCountGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2PlusNewAropiPostBharaliCountGraph/`,
    requestOptions,
  ).then(handleResponse);
}
function get2plusByIdCumulativeCountGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2plusByIdCumulativeCountGraph/`,
    requestOptions,
  ).then(handleResponse);
}
function get2PlusNewAropiPostBharaliCumulativeCountGraph(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/get2PlusNewAropiPostBharaliCumulativeCountGraph/`,
    requestOptions,
  ).then(handleResponse);
}
function GunhaHide(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/GunhaHide/`, requestOptions).then(
    handleResponse,
  );
}
function GunahaHideRequestList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/GunahaHideRequestList/`,
    requestOptions,
  ).then(handleResponse);
}
function deleteGunaHideReuqest(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/deleteGunaHideReuqest/`,
    requestOptions,
  ).then(handleResponse);
}

function CctvMasterDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/CctvMasterDetails/`, requestOptions).then(
    handleResponse,
  );
}
function fuzzyList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/fuzzyList/`, requestOptions).then(
    handleResponse,
  );
}
function crimeNullList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/crimeNullList/`, requestOptions).then(
    handleResponse,
  );
}
function douableCRCrimeList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/douableCRCrimeList/`, requestOptions).then(
    handleResponse,
  );
}
function getTadipaarListByDistrict(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getTadipaarListByDistrict/`,
    requestOptions,
  ).then(handleResponse);
}

function getCctvDistrictsCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getCctvDistrictsCity/`,
    requestOptions,
  ).then(handleResponse);
}
function aropiCountYear(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/aropiCountYear/`, requestOptions);
}
function addCctnsDistrict(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/addCctnsDistrict/`, requestOptions).then(
    handleResponse,
  );
}
function UpdateDistrictOrder(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/UpdateDistrictOrder/`, requestOptions).then(
    handleResponse,
  );
}
function GetOrderDistrict(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/GetOrderDistrict/?cityId=${id}`,
    requestOptions,
  ).then(handleResponse);
}
